"use client";

import { BannerWithTitleOnly } from "#app/_ui/components/banners/BannerWithTitleOnly";
import { AssetsList } from "#app/_ui/components/market-research/asset-list";
import { AssetListPerformance } from "#app/_ui/components/market-research/asset-list-performance";
import { ChartRoulette } from "#app/_ui/components/market-research/chart-roulette";
import { FactsetDisclaimers } from "#app/_ui/components/market-research/factset-disclaimers";
import { FactsetIds } from "#app/_ui/components/market-research/factset-ids";
import { MarketDiaries } from "#app/_ui/components/market-research/market-diaries";
import { MarketNews } from "#app/_ui/components/market-research/MarketNews";
import { StockMostTradedInstruments } from "#app/_ui/components/market-research/stock-most-traded-instruments";
import { StockTopFlop } from "#app/_ui/components/market-research/stock-top-flop";
import { useStockLinkClick } from "#app/_ui/components/market-research/use-stock-link-click";
import { Card, CardContent, CardHeader } from "#ui/card";
import { Container } from "#ui/container";
import { Main } from "#ui/main";
import { H2 } from "#ui/typography";

const usMarketsAssetPerformanceList = [
  "428444",
  "1047672",
  "1197288",
  "980230",
  "1197289",
  "1047705",
  "420527",
  "420526",
  "1047687",
  "1244982",
];

export default function UsMarketContent() {
  const stockLinkClick = useStockLinkClick();

  return (
    <Main>
      <BannerWithTitleOnly title="US Markets" />
      <Container>
        <div className="grid gap-y-30px">
          <Card>
            <CardHeader>
              <H2 size="h5">Major Market Indices</H2>
            </CardHeader>
            <CardContent>
              <ChartRoulette identifiers={FactsetIds.indexes} />
            </CardContent>
          </Card>
          <Card>
            <CardHeader>
              <H2 size="h5">Assets List</H2>
            </CardHeader>
            <CardContent>
              <AssetsList identifiers={FactsetIds.indexes} />
            </CardContent>
          </Card>
          <Card>
            <CardHeader>
              <H2 size="h5">Latest Market News</H2>
            </CardHeader>
            <CardContent>
              <MarketNews
                criteria={{
                  distributorIds: [FactsetIds.news.distrbutorIds.default],
                }}
              />
            </CardContent>
          </Card>
          <Card>
            <CardHeader>
              <H2 size="h5">Gainers</H2>
            </CardHeader>
            <CardContent>
              <StockTopFlop symbolLinkClick={stockLinkClick} type="gainers" />
            </CardContent>
          </Card>
          <Card>
            <CardHeader>
              <H2 size="h5">Losers</H2>
            </CardHeader>
            <CardContent>
              <StockTopFlop symbolLinkClick={stockLinkClick} type="losers" />
            </CardContent>
          </Card>
          <Card>
            <CardHeader>
              <H2 size="h5">Most Active</H2>
            </CardHeader>
            <CardContent>
              <StockMostTradedInstruments symbolLinkClick={stockLinkClick} />
            </CardContent>
          </Card>
          <Card>
            <CardHeader>
              <H2 size="h5">Sector Performance </H2>
            </CardHeader>
            <CardContent>
              <AssetListPerformance
                identifiers={usMarketsAssetPerformanceList}
              />
            </CardContent>
          </Card>
          <Card>
            <CardHeader>
              <H2 size="h5">Market Diaries</H2>
            </CardHeader>
            <CardContent>
              <MarketDiaries identifiers={FactsetIds.indexes} />
            </CardContent>
          </Card>
          <FactsetDisclaimers />
        </div>
      </Container>
    </Main>
  );
}
